import { Method } from 'axios';
import { ELanguage } from '@ringana/configs';
import ApiRoutes from './ApiRoutes';
import { TApiResponse, TApiWpPages } from '../common/types/api.types';
import config from '../../config';
import { IInterestingArticle } from '../common/interfaces/interesting-for-you.interface';
import {
  IApiBooklet,
  IApiExtendedSingleProductData,
  IApiMediaPost,
  IApiPreviewBlogPost,
  IApiRethinkArticle,
  IApiSingleProductData,
  IApiSliderBlogPost,
} from '../common/interfaces/api.interface';
import { IKnowledgeBaseOverview } from '../common/interfaces/knowledge-base-overview.interface';
import { INewsEntry } from '../common/interfaces/news.interface';
import { IShippingCost } from '../common/interfaces/shipping-info.interface';
import { IPostId } from '../common/interfaces/index.interface';
import { IMenus } from '../common/interfaces/header.interface';
import { ISummitDataWP } from '../common/interfaces/summits.interface';
import { ISingleSummitWPData } from '../common/interfaces/single-incentive.interface';
import { ITransparencyReport } from '../common/interfaces/transparency-reports.interface';

const WPAPI_BASEURL = config.wpUrls.restapi.path;

/* eslint-disable camelcase */
export default class WpApiRoutes<TResponse = undefined, TRequestData = undefined, TRequestParams = undefined> extends ApiRoutes<TResponse, TRequestData, TRequestParams> {
  public static getBooklets = new WpApiRoutes<TApiResponse<IApiBooklet[]>, { action: string; lang: ELanguage }>(`/magazines`, `get`);
  public static getExtendedSingleProductData = new WpApiRoutes<IApiExtendedSingleProductData[], { slug: string; wpml_lang: ELanguage }>(`/products/infos/new-details`, `get`);
  public static getInterestingForYou = new WpApiRoutes<TApiResponse<IInterestingArticle[]>, { id: number; lang: ELanguage }>(`/interestingForYou`, `get`);
  public static getKnowledgeBaseOverview = new WpApiRoutes<TApiResponse<IKnowledgeBaseOverview>, { lang: ELanguage }>(`/knowledgeBaseOverview`, `get`);
  public static getMedia = new WpApiRoutes<TApiResponse<IApiMediaPost[]>, { action: string; filter: number; page: number }>(`/press/itm`, `get`);
  public static getMenuItems = new WpApiRoutes<IMenus, { lang: ELanguage }>(`/getMenuItems`, `get`);
  public static getMenuItemsForPartners = new WpApiRoutes<IMenus, { lang: ELanguage }>(`/getMenuItemsForPartners`, `get`);
  public static getNews = new WpApiRoutes<TApiResponse<INewsEntry[]>, { isPartner: boolean; lang: ELanguage; limit: number; page: number }>(`/newsNewRoute`, `get`);
  public static getPostId = new WpApiRoutes<TApiResponse<IPostId>, { url: string }>(`/getPostId`, `get`);
  public static getPreviewPosts = new WpApiRoutes<TApiResponse<IApiPreviewBlogPost[]>, { page?: number; topic: number; wpml_lang: ELanguage }>(`/blog/pposts`, `get`);
  public static getRethinkArticles = new WpApiRoutes<IApiRethinkArticle[], { action: string; wpml_lang: ELanguage }>(`/articles/rethink`, `get`);
  public static getShippingInfo = new WpApiRoutes<TApiResponse<IShippingCost[]>, { lang: ELanguage }>(`/shippingInfo`, `get`);
  public static getSingleProductData = new WpApiRoutes<IApiSingleProductData[], { slug: string; wpml_lang: ELanguage }>(`/products/infos/details`, `get`);
  public static getSliderPosts = new WpApiRoutes<TApiResponse<IApiSliderBlogPost[]>, { topic: number; wpml_lang: ELanguage }>(`/blog/sposts`, `get`);
  public static getSingleSummitData = new WpApiRoutes<TApiResponse<ISingleSummitWPData>, { id: number; lang: ELanguage}>(`/getSummitById`, `get`);
  public static getTransparencyReports = new WpApiRoutes<TApiResponse<ITransparencyReport[]>, { lang: ELanguage }>(`/transparencyReports`, `get`);
  public static getUrls = new WpApiRoutes<TApiWpPages, { pageid: number }>(`/urls`, `get`);
  public static getSummits = new WpApiRoutes<TApiResponse<ISummitDataWP[]>>(`/getSummits`, `get`);

  constructor(url: string, method: Method, withCredentials = false) {
    super(url, method, withCredentials, WPAPI_BASEURL);
  }
}
